import { Component } from '@angular/core';

@Component({
	selector: 'perf-fees-skeleton',
	templateUrl: './fees-skeleton.component.html',
	styleUrls: ['./fees-skeleton.component.scss']
})
export class FeesSkeletonComponent {

	public readonly TABLES_ON_TAB = Array(5).fill(0);
	public readonly GHOST_ROWS = Array(5).fill(0);
	public readonly GHOST_COLUMNS = Array(9).fill(0);

}
